/**
 * Theme Palette Configuration
 * Color system for MUI theme
 */

import { semantic, grey, panelBackgrounds } from '../tokens/colors';

export const palette = {
  mode: 'light',
  
  // Primary color
  primary: {
    main: semantic.primary.main,
    light: semantic.primary.light,
    dark: semantic.primary.dark,
    contrastText: semantic.primary.contrastText,
  },
  
  // Secondary color
  secondary: {
    main: semantic.secondary.main,
    light: semantic.secondary.light,
    dark: semantic.secondary.dark,
    contrastText: semantic.secondary.contrastText,
  },
  
  // Error color
  error: {
    main: semantic.error.main,
    light: semantic.error.light,
    dark: semantic.error.dark,
    contrastText: semantic.error.contrastText,
  },
  
  // Warning color
  warning: {
    main: semantic.warning.main,
    light: semantic.warning.light,
    dark: semantic.warning.dark,
    contrastText: semantic.warning.contrastText,
  },
  
  // Info color
  info: {
    main: semantic.info.main,
    light: semantic.info.light,
    dark: semantic.info.dark,
    contrastText: semantic.info.contrastText,
  },
  
  // Success color
  success: {
    main: semantic.success.main,
    light: semantic.success.light,
    dark: semantic.success.dark,
    contrastText: semantic.success.contrastText,
  },
  
  // Grey scale
  grey: grey,
  
  // Text colors
  text: {
    primary: semantic.text.primary,
    secondary: semantic.text.secondary,
    disabled: semantic.text.disabled,
    hint: semantic.text.hint,
  },
  
  // Background colors
  background: {
    default: semantic.background.default,
    paper: semantic.background.paper,
    elevated: semantic.background.elevated,
    panel: semantic.background.panel,
  },
  
  // Action colors
  action: {
    active: semantic.action.active,
    hover: semantic.action.hover,
    hoverOpacity: semantic.action.hoverOpacity,
    selected: semantic.action.selected,
    selectedOpacity: semantic.action.selectedOpacity,
    disabled: semantic.action.disabled,
    disabledBackground: semantic.action.disabledBackground,
    disabledOpacity: semantic.action.disabledOpacity,
    focus: semantic.action.focus,
    focusOpacity: semantic.action.focusOpacity,
    activatedOpacity: semantic.action.activatedOpacity,
  },
  
  // Divider color
  divider: semantic.divider,
  
  // Custom panel backgrounds
  panel: panelBackgrounds,
  
  // Selection states - for selected items in lists, cards, etc.
  selection: {
    background: 'rgba(33, 150, 243, 0.15)', // Light blue background
    backgroundHover: 'rgba(33, 150, 243, 0.2)', // Slightly darker on hover
    border: 'rgba(33, 150, 243, 0.5)', // Semi-transparent blue border
    backgroundLight: 'rgba(33, 150, 243, 0.08)', // Very light selection
  },
  
  // Overlay backgrounds
  overlay: {
    light: 'rgba(255, 255, 255, 0.9)', // Light overlay
    dark: 'rgba(0, 0, 0, 0.5)', // Dark overlay
    blur: 'rgba(255, 255, 255, 0.95)', // Blur background
  },
  
  // State-specific backgrounds
  states: {
    success: 'rgba(76, 175, 80, 0.08)', // Light green for success states
    warning: 'rgba(255, 152, 0, 0.15)', // Light orange for warning states
    warningBorder: 'rgba(255, 152, 0, 0.5)', // Orange border for warnings
    active: 'rgba(33, 150, 243, 0.15)', // Active state background
    activeBorder: 'rgba(33, 150, 243, 0.5)', // Active state border
  },
};